import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aebfc666"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  enctype: "multipart/form-data",
  novalidate: ""
}
const _hoisted_2 = { class: "dropbox" }
const _hoisted_3 = ["name", "disabled", "accept"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "table"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Namn"),
    /*#__PURE__*/_createElementVNode("th", null, "Storlek"),
    /*#__PURE__*/_createElementVNode("th", null, "Typ"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isInitial || _ctx.isSaving)
      ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              type: "file",
              multiple: "",
              name: _ctx.state.uploadFieldName,
              disabled: _ctx.isSaving,
              accept: _ctx.accept,
              onChange: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.filesChange($event.target.name, $event.target.files);
          _ctx.fileCount = $event.target.files.length;
        }),
              class: "input-file"
            }, null, 40, _hoisted_3),
            (_ctx.isInitial)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createTextVNode(" Dra dina filer hit"),
                  _hoisted_5,
                  _createTextVNode(" eller klicka för att välja.. ")
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Uploading " + _toDisplayString(_ctx.fileCount) + " files...", 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showfiles)
      ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.files, (file, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(file.name), 1),
                _createElementVNode("td", null, _toDisplayString(file.size), 1),
                _createElementVNode("td", null, _toDisplayString(file.type), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.removeFile(file.name))
                  }, "Ta bort", 8, _hoisted_9)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}